import React, { Component } from "react";
import Close from "../Icons/Close";
import Img from "react-image";
import ReactPlayer from "react-player";
import _ from "lodash";
import iconValider from "../styles/img/icon-check-white.svg";
import { connect } from "react-redux";
import {
  addPostCommunaute,
  uploadMomentPhotos,
  uploadMomentVideos,
} from "../modules/kids/kids-list/communaute/Communaute.duck";
import { css } from "@emotion/core";
import DotLoader from "react-spinners/DotLoader";

const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);
class ShaireModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video: false,
      all: true,
      parent: false,
      videoUrl: "",
    };
    this.onPause = this.onPause.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.shaireWith = this.shaireWith.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }

  handleCheck = (event) => {
    if (event.target.name === "all") {
      this.setState({ all: true, parent: false });
    } else {
      this.setState({ all: false, parent: true });
    }
  };
  onPlay() {
    this.setState({
      video: false,
    });
  }
  onPause() {
    this.setState({
      video: true,
    });
  }

  shaireWith = (event) => {
    event.preventDefault();
    if (this.state.parent == true) {
      this.props.shaireWith();
    } else {
      if (_.isEmpty(this.props.values.photo) === false) {
        let tok = localStorage.getItem("token");
        const data = {
          description: "description2",
          dataPost: this.props.dataPost,
          parentsList: [],
        };
        this.props.uploadMomentPhotos(tok, data);
        this.props.cleanData();
      }

      if (_.isEmpty(this.props.values.photo) === true) {
        let tok = localStorage.getItem("token");
        const data = {
          video: this.props.values.file,
          parentsList: [],
        };
        this.props.uploadMomentVideos(tok, data);
        this.props.cleanData();
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loading !== this.props.loading) {
      if (prevProps.loading === true && this.props.loading === false) {
        this.props.onCloseModaleCamera();
      }
    }
  }
  componentWillMount() {
    if (this.props.values.video.length !== 0) {
      var videoUrl = window.URL.createObjectURL(this.props.values.video);
      this.setState({ videoUrl: videoUrl });
    }
  }

  render() {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;
    return (
      <div
        className="modal fade modal-skin show"
        id="modalPostOrSend"
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
        style={{ display: "show", background: "rgba(0, 76, 197, 0.7)" }}
      >
        <div className="modal-dialog modal-dialog-centered " role="document">
          <div className="modal-content camera-dialog">
            <form>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.props.onCloseModaleCamera}
              >
                <Close className="img-fluid" alt="" />
              </button>
              <div className="modal-body">
                <section className="buttons-filters camera-container">
                  <h5 className="modal-title">Instant capturé</h5>
                  {this.props.loading === true ? (
                    <DotLoader
                      size={100}
                      color={"#ff7d26"}
                      css={override}
                      loading={this.props.loading}
                    />
                  ) : (
                    <div className="d-flex justify-content-center ">
                      {Object.getOwnPropertyNames(this.props.values.video)
                        .length === 0 ? (
                        <ReactPlayer
                          volume={1}
                          controls={true}
                          url={this.state.videoUrl}
                          style={{
                            width: "100%",
                            height: "auto"
                          }}
                          playing
                        />
                      ) : (
                        <img
                          src={this.props.values.photo}
                          style={{
                            width: "90%",
                            height: "90%"
                          }}
                        />
                      )}
                    </div>
                  )}
                </section>
                <section>
                  <h5 className="modal-title">
                    Avec qui voulez-vous le partager ?
                  </h5>
                  <ul className="row mx-n2 list-enfants list-sans-avatar">
                    <li className="col-md-6 px-2">
                      <input
                        type="checkbox"
                        id="lundi"
                        name="all"
                        defaultValue="lundi"
                        onChange={this.handleCheck}
                        checked={this.state.all}
                      />
                      <label className="rounded15 box-shadow" htmlFor="lundi">
                        <span className="avatar" />
                        <span className="name">Tout le monde</span>
                      </label>
                    </li>
                    <li className="col-md-6 px-2">
                      <input
                        type="checkbox"
                        id="mardi"
                        name="parent"
                        defaultValue="mardi"
                        onChange={this.handleCheck}
                        checked={this.state.parent}
                      />
                      <label className="rounded15 box-shadow" htmlFor="mardi">
                        <span className="avatar" />
                        <span className="name">Les parents</span>
                      </label>
                    </li>
                  </ul>
                </section>
                <div className="d-flex justify-content-center">
                  <button
                    type="submit"
                    className="btn-gradient btn-valid"
                    data-dismiss="modal"
                    data-toggle="modal"
                    data-target="#modalParents"
                    onClick={this.props.BackCamera}
                  >
                    {" "}
                    Retourner
                  </button>
                  <button
                    type="submit"
                    className="btn-gradient btn-valid"
                    data-dismiss="modal"
                    data-toggle="modal"
                    data-target="#modalParents"
                    onClick={this.shaireWith}
                  >
                    <IconValider /> Valider
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dataPost: state.Communaute.data,
  media: state.Communaute.data.media,
});

export default connect(mapStateToProps, {
  addPostCommunaute,
  uploadMomentPhotos,
  uploadMomentVideos,
})(ShaireModal);
